var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 40,
    viewBox: "0 0 100 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_83_1043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.22 0H25.352V21.598C25.352 25.3165 23.78 33.1058 12.5 33.1058C1.22 33.1058 0 25.8511 0 21.7762V17.7944H7.868V21.6911C7.868 24.081 9.444 26.2927 12.416 26.2927C15.388 26.2927 17.216 24.6117 17.216 21.7803L17.22 0Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4841 17.8795C42.4841 15.6679 41.2641 13.5413 38.4641 13.5413C35.7521 13.5413 34.7921 15.4896 34.7921 17.8795H42.4841ZM37.9401 8.58329C44.3401 8.58329 49.9161 11.0623 49.9161 22.481H34.8001C34.8001 26.1266 36.2881 27.6132 38.9081 27.6132C39.6308 27.6382 40.3453 27.4512 40.9655 27.0746C41.5858 26.698 42.0853 26.148 42.4041 25.4906H49.8361C49.8361 28.7676 45.3801 33.1868 38.6361 33.1018C30.9441 33.1018 27.1841 27.3499 27.1841 21.4157C27.1841 15.4815 30.5041 8.57924 37.9361 8.57924",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8001 17.8795C66.8001 15.6678 65.5801 13.5413 62.7801 13.5413C60.0721 13.5413 59.1081 15.4896 59.1081 17.8795H66.8001ZM62.2401 8.58734C68.6401 8.58734 74.2161 11.0663 74.2161 22.4851H59.0921C59.0921 26.1306 60.5801 27.6172 63.2001 27.6172C63.9228 27.6422 64.6373 27.4552 65.2575 27.0786C65.8778 26.7021 66.3773 26.152 66.6961 25.4947H74.1281C74.1281 28.7716 69.6721 33.1909 62.9281 33.1058C55.2361 33.1058 51.4761 27.3539 51.4761 21.4197C51.4761 15.4856 54.7961 8.58328 62.2281 8.58328",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5681 21.1483C83.4801 25.6608 84.4401 28.0344 88.1121 28.0344C91.7841 28.0344 92.3081 23.9635 92.3081 20.8648C92.3081 17.7661 91.6001 14.7727 87.7601 14.7727C85.4001 14.7727 83.6521 16.6319 83.5641 21.1443M76.1321 40V9.47038H83.6481V12.9499C83.9082 12.3287 84.2617 11.7521 84.6961 11.2405C85.2041 10.6208 86.6201 8.85063 90.3761 8.85063C94.1321 8.85063 99.9761 11.5078 99.9761 20.8891C99.9761 28.1478 96.4801 33.4461 90.4481 33.4461C87.1281 33.4461 85.6481 32.2754 84.7681 31.5868C84.3642 31.2914 84.0102 30.9317 83.7201 30.5215V39.9959L76.1321 40Z",
    fill: "black",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_1043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigLogo);
export default __webpack_public_path__ + "static/media/big-logo.5d8543317ac19d45f0aa7d4e1820661a.svg";
export { ForwardRef as ReactComponent };